import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
    selector: 'e-query-details-text-field',
    template: require('./e-query-details-text-field.component.html'),
    styles: [require('./e-query-details-text-field.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class EQueryDetailsTextFieldComponent {
    @Input()
    public labelText: string;

    @Input()
    public textValue: string;
}